import { Modal } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "@material-ui/icons/Close";
import { useDashboards } from "MyDashboards/api/useDashboards.hook";
import useDashboardEditor from "MyDashboards/state/editor";
import { Element, SlideMeta } from "MyDashboards/state/editorTypes";
import { Dashboard } from "MyDashboards/types/api";
import px from "MyDashboards/utils/px";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Loader from "qpr-base/ui/components/Loader";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as ImportIcon } from "../../assets/importIcon.svg";
import * as renderers from "../Render";
import RenderSelectedSlide from "../SlideView/RenderSlide";
import useImportSlideModalStyles from "./themes";

const RenderElement = (props: { el: Element }) => {
  const { el } = props;
  if (props.el.component) {
    if (props.el.component.component === "Highcharts") {
      return <div>Highcharts component {props.el.component.data.message}</div>;
    }
  }
  return (
    <div
      style={{
        width: px(el.width),
        height: px(el.height),
        background: "rgba(0,100,255,0.1)",
      }}
    />
  );
};

/**
 *
 * only pass to it dashboard that have dashboardData and at least one slide
 */
const DashboardThumbnail = (props: { dashboard: Dashboard; width: number }) => {
  const classes = useImportSlideModalStyles();
  const { dashboard, width } = props;
  const slide = (dashboard.dashboardData as SlideMeta).pages[0];
  const editorWidth = useDashboardEditor((e) => e.editorWidth);
  return (
    <div
      className={classes.slidePrev}
      style={{ height: px((width * slide.height) / slide.width + 40) }}
    >
      <RenderSelectedSlide
        slide={slide}
        width={(width * editorWidth) / slide.width}
        RenderElement={RenderElement}
        containerClass="thumb"
        registry={renderers.thumbNails}
      />
      <div className={classes.slideTitle}>{dashboard.name}</div>
    </div>
  );
};

interface ImportSlideModalProps {
  open: boolean;
  onClose: VoidFunction;
  onDashboardSelected: (dsahboard: Dashboard) => void;
}

const ImportDashboardModal: FunctionComponent<ImportSlideModalProps> = (
  props
) => {
  const classes = useImportSlideModalStyles();
  const { t } = useTranslation();
  const ctx = useAppContext();
  const languageName = ctx.language;
  const { data: dashboards, isLoading } = useDashboards({ languageName });

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        dir={ctx.rtl ? "rtl" : "ltr"}
        open={props.open}
        onClose={props.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        style={{ zIndex: 99999 }}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {isLoading ? (
          <Loader />
        ) : (
          <Fade in={props.open}>
            <div className={classes.body}>
              <div className="title">
                <div className="icon">
                  <div className="bg">
                    <ImportIcon />
                  </div>
                </div>
                <div className="titleText">{t("myStories.Import slides")}</div>
                <div className="closeIcon" aria-hidden onClick={props.onClose}>
                  <CloseIcon />
                </div>
              </div>

              <div className="content">
                <div className="header">
                  {t("myStories.Select From Existing Presentations")}
                </div>
                <div className="layouts">
                  {dashboards
                    ?.filter(
                      (d) =>
                        d.dashboardData && d.dashboardData.pages?.length > 0
                    )
                    .map((dashboard: Dashboard) => (
                      <div
                        onClick={() => props.onDashboardSelected(dashboard)}
                        aria-hidden
                        key={dashboard._id}
                      >
                        <DashboardThumbnail dashboard={dashboard} width={220} />
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </Fade>
        )}
      </Modal>
    </div>
  );
};

export default ImportDashboardModal;
